<template>
  <!-- 成绩 -->
  <div class="sub-page">
     <a-collapse  expandIconPosition="right" class="coll" >
            <a-collapse-panel key="1">
              <div slot="header">
              <div class="project-name">参赛代表队参赛代表队参赛代表队参赛代表队</div>
             </div>
             <div class="medal">
              <div class="tab-medal">
                <div class="tab-box" :style="{width:medalList.length*200+'px'}">
                  <div class="tab-list">
                    <div class="tab-item" v-for="(item,index) in medalList" :key="index" @click="handleMatch(item,index)" :class="medalIndex==index?'active':''">
                      <div>{{item.channel}}</div>
                      <div>{{item.name}}</div>
                      <div>{{item.dtime}}</div>
                      <!-- <div v-show="medalIndex==index"></div> -->
                    </div>
                    </div>
                </div>
              </div>
              <div class="player-list">
                <div class="row title">
                  <div class="col-1">排名</div>
                  <div class="col-2">跑道</div>
                  <div class="col-3">代表队</div>
                  <div class="col-4">运动员</div>
                  <div class="col-5">出生年月</div>
                  <div class="col-6">反应时间</div>
                  <div class="title-7">成绩</div>
                  <div class="col-8">落后时间</div>
                </div>
                <div class="row" v-for="(item,index) in programTeamList" :key="index">
                  <div class="col-1">{{item.id}}</div>
                  <div class="col-2">{{item.step}}</div>
                  <div class="col-3">{{item.teamName}}</div>
                  <div class="col-4">{{item.playerName}}</div>
                  <div class="col-5">{{item.date}}</div>
                  <div class="col-6">{{item.time}}</div>
                  <div class="col-7">
                    <div>{{item.score.ranking==1?'晋级':'淘汰'}}</div>
                    <div>{{item.score.scoreNum}}</div>
                  </div>
                  <div class="col-8">{{item.lastTime}}</div>
                </div>
              </div>
             </div>
            </a-collapse-panel>
        </a-collapse>
  </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
          activeKey:1,
          medalIndex:0,
          medalList:[
            {channel:"官方发布",name:"决赛",dtime:"2023.08.31 15:30"},
            {channel:"官方发布",name:"决赛",dtime:"2023.08.31 15:30"},
            {channel:"官方发布",name:"决赛",dtime:"2023.08.31 15:30"},
            {channel:"官方发布",name:"决赛",dtime:"2023.08.31 15:30"},
            {channel:"官方发布",name:"决赛",dtime:"2023.08.31 15:30"},
            {channel:"官方发布",name:"决赛",dtime:"2023.08.31 15:30"},
            {channel:"官方发布",name:"决赛",dtime:"2023.08.31 15:30"},
            {channel:"官方发布",name:"决赛",dtime:"2023.08.31 15:30"},
            {channel:"官方发布",name:"决赛",dtime:"2023.08.31 15:30"},
          ],
          programTeamList:[
            {id:1,step:3,teamName:"代表队1",playerName:"运动员1",date:"2015.02.23",time:"0.38",score:{ranking:0,scoreNum:2},lastTime:"0.244"},
            {id:2,step:8,teamName:"代表队2",playerName:"运动员2",date:"2015.02.23",time:"0.38",score:{ranking:1,scoreNum:32},lastTime:"0.244"},
            {id:3,step:6,teamName:"代表队3",playerName:"运动员3",date:"2015.02.23",time:"0.38",score:{ranking:0,scoreNum:2},lastTime:"0.325"},
            {id:4,step:2,teamName:"代表队4",playerName:"运动员4",date:"2015.02.23",time:"0.38",score:{ranking:2,scoreNum:32},lastTime:"0.244"},
            {id:5,step:1,teamName:"代表队5",playerName:"运动员5",date:"2015.02.23",time:"0.38",score:{ranking:0,scoreNum:3},lastTime:"0.244"},
          ]
        }
    },
    mounted () {
    },
    methods: {
        handleMatch(item,index) {
          console.log(item,index);
            this.medalIndex = index
        }
    },
}
</script>

<style lang="scss" scoped>
.sub-page{
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
   .coll{
      width: 100%;
      background-color: #ffffff;
      .project-name{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 18px;
        line-height: 40px;
        font-weight: 600;
      }
      .medal{
          width: 100%;
          .tab-medal{
            width: 1140px;
            margin: 0 auto;
            overflow: auto;
            overflow-y: hidden;
            height: 100px;
            font-size: 14px;
            .tab-box {
              width: 9999px;
              height: 100px;
               .tab-list{
                display: flex;
                height: 80px;
                justify-content: flex-start;
                flex-wrap: nowrap;
                .tab-item{
                  width: 200px;
                  cursor: pointer;
                  margin-right: 20px;
                  position: relative;
                  display: flex;
                  justify-content: center;
                  flex-wrap: nowrap;
                  flex-direction: column;
                  box-sizing: border-box;
                  align-items: center;
                  div:first-child{
                    background-color: #AA1F23;
                    border-radius: 0 0 6px 6px;
                    width: 80px;
                    color: #ffffff;
                    text-align: center;
                    height: 24px;
                  }
                  div:nth-child(2){
                    color: #000000;
                    font-size: 16px;
                    font-weight: bold;
                  }
                  div:nth-child(3){
                    color: #999999;
                    font-size: 14px;
                  }
                  // div:last-child{
                  //   width: 100%;
                  //   height: 4px;
                  //   background-color: #AA1F23;
                  // }
                }
                .tab-item::after{
                  content:"";
                  height: 50px;
                  width: 2px;
                  background-color: #C4C4C4;
                  position: absolute;
                  top: 10px;
                  right: -10px;
                }
                .active{
                  border-bottom: 4px solid #AA1F23;
                }
              }
             }
          }
        }
      /deep/ .ant-collapse-header{
        height: 70px;
        text-align: center;
        border-bottom: 1px solid #E1E1E1;
      }
      .player-list{
        width: 100%;
        .row{
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-align: center;
          height: 70px;
          box-sizing: border-box;
          border-bottom: 1px solid #E1E1E1;
          font-weight: bold;
          font-size: 14px;
           .col-1{
            width: 10%;
          }
          .col-2{
            width: 10%;
          }
          .col-3{
            width: 22%;
            text-align: left;
          }
          .col-4{
            width: 20%;
            text-align: left;
          }
          .col-5{
            width: 10%;
          }
          .col-6{
            width: 10%;
          }
          .col-7{
            width: 8%;
            display: flex;
            height: 70px;
            flex-direction: column;
            position: relative;
            div:first-child{
              background-color: #AA1F23;
              width: 100%;
              height: 24px;
              border-radius: 0 0 6px 6px;
              position: absolute;
              top: 0;
              left: 0;
              color: #ffffff;
              font-size: 14px;
              text-align: center;
            }
            div:last-child{
              width: 100%;
              position: absolute;
              top: 28px;
              left: 0;
            }
          }
          .col-8{
            width: 10%;
          }
        }
        .title{
          font-size: 16px;
           .title-7{
            width: 8%;
           }
        }
       
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/match/trackfield/components/TrackfieldAchievement.vue